
export class SupplementaryEquipmentSight {

	id: number;

    constructor(equipment?: any) {
        if (equipment != null) {
            this.id = equipment.id;
        }
    }

}